import { render, staticRenderFns } from "./Formpart.vue?vue&type=template&id=7840859a&scoped=true&"
import script from "./Formpart.vue?vue&type=script&lang=js&"
export * from "./Formpart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7840859a",
  null
  
)

export default component.exports